module.exports = __webpack_public_path__ + "img/data-sheet_-valimail-defend-3_07.f6b0085b.png";